import React from "react";

let date = new Date().getFullYear()

const Copyright = (props) => (
    <p {...props}> &copy; {date} Rent Ready Manager </p>
)

export default Copyright